/** Circular plug badge: green = DM connected, red = custom integration needed. */

const CONNECTED_TITLE =
  "Connected — FC2 can load projects and files in this hub.";

const DISCONNECTED_TITLE = "Custom integration needed";

function PlugGlyph({ slash }: { slash?: boolean }) {
  return (
    <g transform="translate(12 12) rotate(-18) translate(-12 -12)">
      <rect x="8.5" y="5" width="2.2" height="4.5" rx="0.6" fill="#fff" />
      <rect x="13.3" y="5" width="2.2" height="4.5" rx="0.6" fill="#fff" />
      <rect x="7" y="9.5" width="10" height="6.5" rx="1.2" fill="#fff" />
      {slash && (
        <path
          d="M6 18L18 6"
          stroke="#fff"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
      )}
    </g>
  );
}

export function AccHubDmStatusIcon({
  dmProvisioned,
  size = 18,
}: {
  dmProvisioned?: boolean;
  size?: number;
}) {
  const connected = dmProvisioned === true;
  const title = connected ? CONNECTED_TITLE : DISCONNECTED_TITLE;
  const fill = connected ? "#22c55e" : "#ef4444";

  return (
    <span
      title={title}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        flexShrink: 0,
        cursor: "help",
        verticalAlign: "middle",
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <title>{title}</title>
        <circle cx="12" cy="12" r="12" fill={fill} />
        <PlugGlyph slash={!connected} />
      </svg>
    </span>
  );
}
